export const instanceLabels:Record<string,string>={running:'运行正常',unknown:'状态待确认',missing:'运行目录缺失',stopped:'已下线',cleaned:'已清理',checking:'检查中',stopping:'下线中',cleaning:'清理中',rebuilding:'重建中',starting:'启动中',verifying:'验证中',failed:'需要处理'};
